module.exports = "#define GLSLIFY 1\nvec3 objectNormal = vec3( normal );\n"